/**
* @Author: zpc
* @Description:
* @DateTime: Created in 2022-03-18 10:05:00
*/

import {Component,Prop} from 'vue-property-decorator'
import BasicSearchPage from "../../../../components/basicSearchPage/basicSearchPage";
import override from "../../../../dectorators/override";
import CheckLogService from './checkLogService';
import { SnConfigDOI } from '../api/snConfigApi';
import QueryForm from 'src/components/queryForm/queryForm';

@Component
export default class CheckLog extends BasicSearchPage<CheckLogService, SnConfigDOI.RowDataIs> {
    @Prop({
		type: String
	})
    sn!: string
    
    checkBoxShow = false

    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
        this.service = new CheckLogService(this)
    }
}